import felipeG from '../assets/felipe.jpg';
import elyseH from '../assets/elyse.jpg';
import sejeong from '../assets/sejong.jpg';
import aftonV from '../assets/afton.jpg';
import chivasW from '../assets/chivas.jpg';
import inline1 from '../assets/s1.jpg';
import inline1M from '../assets/s1-m.jpg';
import inline2 from '../assets/s2.jpg';
import inline2M from '../assets/s2-m.jpg';
import inline3 from '../assets/s3.jpg';
import inline3M from '../assets/s3-m.jpg';
import inline4 from '../assets/s4.jpg';
import inline4M from '../assets/s4-m.jpg';
import inline5 from '../assets/s5.jpg';
import inline5M from '../assets/s5-m.jpg';
import inline6 from '../assets/s6.jpg';
import inline6M from '../assets/s6-m.jpg';
import factbox1 from '../assets/multiple.svg';
import factbox2 from '../assets/precollege.svg';

export const lang = {
  intro: {
    head: ['Where ', 'STEM', ' Success Begins'],
    hyperlinkdata: {
      href:
        'https://www.regeneron.com/responsibility/sts-isef?utm_source=cnn&utm_medium=paid-partnership&utm_campaign=isef_usa&utm_id=MediaPartnership&utm_term=Article1&utm_content=article2_header#2',
      copy: 'Regeneron International Science and Engineering Fair (ISEF)'
    },
    subhead: [
      'How the ',
      ' paves the way for student success in science, technology, engineering, and math (STEM) careers.'
    ],
    copy: [
      'The frontiers of human knowledge and capability are expanding rapidly. Yet we still face significant challenges in areas such as health, energy, climate, economic inequality, and more. As the world increasingly relies on scientists and engineers for innovative solutions, STEM fields are expected to see rapid job growth in the years ahead.',
      'Regeneron ISEF, a program founded and produced by the Society for Science that has become the world’s largest pre-collegiate STEM competition, helps encourage and empower the next generation of STEM talent. With a rich history spanning over 70 years, Regeneron ISEF has convened some of the most promising young scientists to showcase their innovation on a global stage while using their high-school research as a springboard for academic achievement and professional success.',
      'The impacts are profound. Regeneron ISEF finalists not only compete for awards but also embark on a path of personal and professional growth. Here, we delve into the lives of five ISEF alumni, each revealing how the competition was more than a milestone—it was a catalyst that shaped their futures and prepared them to thrive in their STEM careers.'
    ]
  },
  panelists: {
    head: 'Meet the ISEF Alumni Panelists',
    content: [
      {
        photo: felipeG,
        panelist: 'Felipe Gómez del Campo',
        title: 'CEO of Specter Aerospace',
        year: '2012',
        copy:
          'Felipe founded his company as an undergraduate student by building on the work he presented at ISEF. Specter Aerospace develops hypersonic flight technology for both defense and commercial sectors.',
        c: 'felipe',
        quotes: [
          [
            [
              'r',
              'ISEF played a major role in leading me from science to technical entrepreneurship. For more than a decade, I have been on a journey to find ways to use electrical discharges to improve how fuel burns…'
            ],
            [
              'b',
              'I scratched the surface of this challenge with my ISEF project, and it subsequently informed all my academic work and became the technological basis for our company.'
            ]
          ],
          [
            ['r', 'ISEF was a watershed moment for me...'],
            [
              'b',
              'It gave me the confidence that by applying science and engineering effectively, I could look at a problem and come up with a solution.'
            ],
            [
              'r',
              ' I knew that I wanted to work for the rest of my career on getting those solutions—not only showing them at a science fair or presenting them in a paper but getting them out into the world.'
            ]
          ],
          [
            [
              'r',
              'It’s incredibly hard to come up with new, impactful technologies that can work in the marketplace. That '
            ],
            ['b', 'innovation only happens if people are passionate and believe they can do it.'],
            [
              'r',
              ' Receiving the inspiration that your science can change the world is probably the greatest outcome from ISEF.'
            ]
          ],
          [
            [
              'r',
              'One of the most important aspects of Regeneron ISEF is the awards ceremony. It’s one thing to win a prize at your school science fair but '
            ],
            [
              'b',
              'getting recognition on ISEF’s global stage really takes it to the next level and opens students’ eyes to the ways they can change the world.'
            ]
          ]
        ]
      },
      {
        photo: elyseH,
        panelist: 'Elyse Hope',
        title: 'Strategic Initiative Manager at the Science Philanthropy Alliance',
        years: '2004, 2005, and 2006',
        copy:
          'With a Ph.D. in Genome Sciences, Elyse combines scientific expertise with a passion for promoting science research funding. She serves as a judge at regional and state science fairs, as well as at Regeneron ISEF.',
        c: 'elyse',
        quotes: [
          [
            [
              'r',
              'My project focused on sunspot research using publicly available data from NASA. As one question led to another, '
            ],
            ['b', 'it pushed me to find the edges of my abilities and then go even further'],
            ['r', ' into learning new skills such as coding or sphere-related math.']
          ],

          [
            [
              'r',
              'Many of my specific memories from ISEF have to do with my peers and the feeling of entering a scientific community for the first time. ISEF lays the groundwork for '
            ],
            ['b', 'making connections, seeing different viewpoints, and finding a common language'],
            ['r', ' for doing science as part of a collaborative community.']
          ],
          [
            [
              'b',
              'There’s power to be gained from branching out and thinking about how to cross boundaries. '
            ],
            [
              'r',
              'At ISEF, I competed in environmental science, physics, and astrophysics. In college, I began in astrophysics but then transitioned to sports medicine, conducted some traumatic brain injury research, ventured into genomics, and eventually became a microbial geneticist. Now I work in philanthropy! Each of these fields has provided me with the room to learn and given me problems to solve.'
            ]
          ],
          [
            [
              'r',
              'I joke that 50% of the reason that I got a PhD was so that I could be a judge at ISEF. In fact, I registered to judge at ISEF the day after I got my degree. Now, when I return to Regeneron ISEF as a judge, I try to come early to attend the opening ceremony, because '
            ],
            [
              'b',
              'that experience of seeing a world full of students who are excited about science, math, engineering, and doing research is incredibly powerful.'
            ],
            [
              'r',
              ' Regeneron ISEF is about much more than prizes—it’s about people and scientists who are trying to leave this world better than we found it.'
            ]
          ]
        ]
      },
      {
        photo: sejeong,
        panelist: 'Se Jeong',
        title: 'Scientist at Regeneron',
        years: '2009 and 2010',
        copy:
          'Se specializes in creating advanced scientific testing for tumor-immune environment research. He is concurrently pursuing an MBA to blend his scientific acumen with business strategy.',
        c: 'sejeong',
        quotes: [
          [
            [
              'r',
              'I feel like I made lifelong friends at ISEF—not only from within the U.S. but also from across the Atlantic. While ISEF is a competition, my primary goal was to '
            ],
            ['b', 'learn and expose myself to a diverse group of pure scientific talent.'],
            ['r', ' I believe having that attitude allowed me to make some amazing connections.']
          ],
          [
            [
              'r',
              'To this day, I still remember the judges who stopped by to talk with me. They were super enthusiastic and '
            ],
            [
              'b',
              'encouraged me to continue to pursue not just scientific research, but especially cancer research.'
            ],
            [
              'r',
              ' Those conversations had a lasting impact on me and influenced my career trajectory.'
            ]
          ],
          [
            [
              'r',
              'Even though I was competing in medical translational science during my time in ISEF, I had the opportunity to browse through completely different areas such as engineering and plant science. '
            ],
            [
              'b',
              'Exploring different disciplines can open your eyes to strides being made in many scientific fields.'
            ],
            [
              'r',
              ' That’s important because I do feel like cooperation and collaboration are key drivers of scientific success.'
            ]
          ],
          [
            [
              'r',
              'We need to cultivate the next generation of STEM talent because previous generations cannot solve all the pressing global problems around the environment, climate, and health that the world faces today. '
            ],
            [
              'b',
              'By doing a solid research project as a high school student, you can become knowledgeable about the process of science and carry that knowledge wherever you go in life.'
            ]
          ]
        ]
      },
      {
        photo: aftonV,
        panelist: 'Afton Vechery',
        title: 'Co-Founder of Modern Fertility',
        year: '2005',
        copy:
          'Modern Fertility offers access to personalized fertility information, and Afton focuses on investing in and advising healthcare companies and serves on the Board of Trustees at the Society for Science.',
        c: 'afton',
        quotes: [
          [
            [
              'r',
              'My ISEF project investigated wells in my community that were contaminated with bacteria. At the end of the science fair, I realized that no one was doing anything about the problem, so I decided to start a company that offered water testing services. '
            ],
            [
              'b',
              'This gave me exposure to scaling science through entrepreneurship. That led to a college scholarship and got me started toward a career path of taking scientific findings'
            ],
            ['r', ' and making them more accessible to the public.']
          ],
          [
            [
              'r',
              'It’s really upsetting to watch the news and hear about all of the sad or terrible things happening in the world today, but spending time with students at ISEF, '
            ],
            [
              'b',
              'seeing how smart they are, how determined they are, and how committed they are to changing the world'
            ],
            ['r', ' with their amazing initiatives—it gives you a real sense of optimism.']
          ],
          [
            [
              'b',
              'ISEF gives young kids exposure to the scientific method, teaching them how to be engaged and scientifically literate.'
            ],
            [
              'r',
              ' That’s why I decided to join the Board of the Society for Science and advance their efforts. It’s also why I’m passionate about getting more companies involved in Regeneron ISEF—whether that’s by making donations, sponsoring categories, or volunteering to serve as judges.'
            ]
          ]
        ]
      },
      {
        photo: chivasW,
        panelist: 'Chivas Wakuta',
        title: 'Director of Development Program Management at Regeneron',
        year: '2003',
        copy:
          'Chivas’ work involves gene therapies targeting auditory disorders and neurogenerative diseases. He’s also passionate about giving back through volunteerism.',
        c: 'chivas',
        quotes: [
          [
            [
              'r',
              'Before I went to ISEF, I had no idea that science received so much attention. Being there at the conference and seeing what a big deal it was made me feel really proud.'
            ],
            ['b', ' This pride helped me feel more confident in pursuing a career in science.']
          ],
          [
            [
              'r',
              'ISEF matters today for the same reason it did when I was competing—it gives people '
            ],
            ['b', 'an opportunity to see the world through science'],
            ['r', ' and to interact with other people like themselves with common interests.']
          ],
          [
            [
              'r',
              'There are lots of opportunities while you’re at ISEF to make connections with people who work in the industry and are there serving as judges or ambassadors…In fact, '
            ],
            [
              'b',
              'I’d encourage students to dive deeper and ask judges or company ambassadors, “What kind of work do you actually do as a scientist?”'
            ],
            [
              'r',
              ' That’s how you might find out that someone works at creating medicines for a certain disease. It’s also how you can get a better understanding of the different opportunities in the larger STEM universe.'
            ]
          ],
          [
            ['r', 'The students competing at Regeneron ISEF today are not only super smart, but '],
            ['b', 'they seem so ready to embrace change and think differently'],
            [
              'r',
              ' that I am constantly learning from them. When it comes to science, I feel like they are going to ask bigger questions and push the boundaries of science even farther.'
            ]
          ]
        ]
      }
    ]
  },

  chapters: {
    head: ['5 Powerful Lessons from Regeneron ISEF', 'Empowering the Next Generation'],
    copy: [
      [
        'For many budding scientists and engineers, competing at Regeneron ISEF can be a life-changing experience. Here are some essential lessons our panelists gleaned from the competition that helped launch their successful STEM careers:'
      ],
      [
        'By bringing together some of the brightest young student scientists and engineers from around the world and giving them plentiful opportunities for inspiration, mentorship, and intellectual exploration, ',
        {
          href:
            'https://www.regeneron.com/responsibility/sts-isef?utm_source=cnn&utm_medium=paid-partnership&utm_campaign=isef_usa&utm_id=MediaPartnership&utm_term=Article1&utm_content=article2_footer#2',
          copy: 'Regeneron ISEF'
        },
        ' is nurturing the next generation of STEM innovators. Our ISEF alumni explain why science competitions like Regeneron ISEF play such an important role in building progress and innovation in STEM fields.'
      ]
    ],
    chapter1: {
      head: '1.	Cultivate Curiosity',
      copy:
        'Exploring scientific inquiry for its own sake can be exhilarating, and basic research conducted today can lay the groundwork for practical applications to come. That said, many Regeneron ISEF participants have discovered that science can not only add value in the future, but it is also a powerful tool for solving real-world problems right now. Science can serve as a means to address injustices, spread knowledge, and make the world a better place.',
      quotes: [
        [3, 0],
        [0, 0]
      ]
    },
    chapter2: {
      head: '2.	Build Confidence in Your STEM Identity',
      copy:
        'By the time students reach Regeneron ISEF, they have already established the value and validity of their research by winning in their local and regional fairs. Reaching this level of academic achievement offers students an enormous confidence boost that can sustain them through the years of hard work required to build STEM careers.',
      quotes: [
        [0, 1],
        [4, 0],
        [1, 0]
      ]
    },
    chapter3: {
      head: '3.	Expand Inclusivity and Community in STEM',
      copy:
        'All our alumni panelists emphasized the spirit of camaraderie and belonging that prevails at Regeneron ISEF. Being part of this vibrant scientific community ignites a spark in many Regeneron ISEF participants, opening their minds to the vast range of exciting STEM opportunities that are available for them to pursue.',
      quotes: [
        [4, 1],
        [1, 1],
        [2, 0]
      ]
    },
    chapter4: {
      head: '4.	Put Mentorship at the Forefront',
      copy:
        'Attending Regeneron ISEF gives high school students a rare opportunity to interact with leading academic and industry professionals who are at the top of their fields. Such interactions can inspire or even lead to fruitful professional bonds—whether that means doing research at a certain university laboratory, gaining internship opportunities in industry, or getting suggestions and encouragement on solving a particular STEM challenge.',
      quotes: [
        [4, 2],
        [2, 1]
      ]
    },
    chapter5: {
      head: '5.	Get Inspired by Innovation',
      copy:
        'Doing a science project at the high school level may be purposeful and exciting but presenting that project at Regeneron ISEF can take that excitement to the next level. Several of our panelists shared how Regeneron ISEF expanded their worldview and turbocharged their enthusiasm for science and careers in STEM.',
      quotes: [
        [3, 1],
        [1, 2],
        [2, 2],
        [0, 2]
      ]
    },
    chapter6: {
      quotes: [
        [3, 2],
        [1, 3],
        [2, 3],
        [0, 3],
        [4, 3]
      ]
    }
  },
  inline: [
    {
      srcD: inline1,
      srcM: inline1M
    },
    {
      srcD: inline2,
      srcM: inline2M
    },
    {
      srcD: inline3,
      srcM: inline3M
    },
    {
      srcD: inline4,
      srcM: inline4M
    },
    {
      srcD: inline5,
      srcM: inline5M
    },
    {
      srcD: inline6,
      srcM: inline6M
    }
  ],
  factbox: [
    {
      icon: factbox1,
      copy:
        'Students who compete in multiple STEM competitions are 3x more likely to pursue a career in STEM.',
      source: ['Source: ', 'International Journal of Science Education']
    },
    {
      icon: factbox2,
      copy:
        'Pre-college students who participate in STEM competitions are more likely to express interest in STEM-related careers by the end of high school.',
      source: ['Source: ', 'International Journal of Science Education']
    }
  ],
  infographic: {
    head: 'The lucrative, thriving world of STEM careers',
    number: ['Nearly 10 million', '~11%', 'Over $95K'],
    stat: [
      'U.S. workers in STEM occupations in 2021',
      'Growth in STEM jobs by 2031–over 2x faster than the growth rate of non-STEM occupations',
      'Median STEM wages vs. $40,120 for non-STEM workers'
    ],
    source: ['Source: ', 'U.S. Department of Labor']
  },
  vimeo: {
    id: '889209920',
    idmobile: '889547760'
  },
  cta: {
    href:
      'https://www.regeneron.com/responsibility/sts-isef?utm_source=cnn&utm_medium=paid-partnership&utm_campaign=isef_usa&utm_id=MediaPartnership&utm_term=Article1&utm_content=article2_footer#2',
    copy: 'HERE',
    copy1: 'CLICK ',
    copy2: ' TO LEARN MORE ABOUT REGENERON ISEF'
  },
  button: {
    href:
      'http://regeneronfutureofstem.com/?utm_medium=paid-partnership&utm_source=cnn&utm_campaign=isef_usa&utm_content=article2_trafficdriver_article1',
    copy: 'READ ABOUT THE GLOBAL FUTURE OF STEM'
  }
};
